import { render, staticRenderFns } from "./Main2018.vue?vue&type=template&id=77b6f98c"
import script from "./Main2018.vue?vue&type=script&lang=js"
export * from "./Main2018.vue?vue&type=script&lang=js"
import style0 from "./Main2018.vue?vue&type=style&index=0&id=77b6f98c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports